import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import ImageGallery from 'react-image-gallery';
import "./../image-gallery.css";

export default () => {
    const title = 'Открыт Мемориальный Дом-музей Костюшко';

    const images = [
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot000.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot000.jpg'),
            description: 'Юные участники открытия'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot001.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot001.jpg'),
            description: 'Театрализованное представление'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot002.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot002.jpg'),
            description: 'Театрализованное представление'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot003.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot003.jpg'),
            description: 'Театрализованное представление'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot004.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot004.jpg'),
            description: 'Театрализованное представление'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot005.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot005.jpg'),
            description: 'Памятная доска'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot006.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot006.jpg'),
            description: 'Место сбора - дом Костюшко'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot007.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot007.jpg'),
            description: 'Дорога к дому'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot008.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot008.jpg'),
            description: 'Полонез'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot009.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot009.jpg'),
            description: 'Полонез'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot010.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot010.jpg'),
            description: 'Начало митинга'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot011.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot011.jpg'),
            description: 'Ленточка'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot012.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot012.jpg'),
            description: 'Возложение цветов'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot013.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot013.jpg'),
            description: 'Возложение цветов'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot014.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot014.jpg'),
            description: 'Возложение цветов'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot015.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot015.jpg'),
            description: 'Участники торжества'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot016.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot016.jpg'),
            description: 'Участники торжества'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot017.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot017.jpg'),
            description: 'Выступления заместителя председателя Брестского облисполкома Цуприка Л. А., который вручил награды за возведение дома'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot018.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot018.jpg'),
            description: 'Участники торжества'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot019.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot019.jpg'),
            description: 'Чрезвычайный и Полномочный Посол США в Республике Беларусь Джордж Крол'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot020.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot020.jpg'),
            description: 'Выступление гостей'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot021.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot021.jpg'),
            description: 'Выступление гостей'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot022.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot022.jpg'),
            description: 'Выступление гостей'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot023.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot023.jpg'),
            description: 'Выступление гостей'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot024.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot024.jpg'),
            description: 'Выступление гостей'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot025.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot025.jpg'),
            description: 'Выступление гостей'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot026.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot026.jpg'),
            description: 'Ключ от музея'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot027.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot027.jpg'),
            description: 'Участники торжества'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot028.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot028.jpg'),
            description: 'Участники торжества'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot029.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot029.jpg'),
            description: 'Перерезание ленты'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot030.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot030.jpg'),
            description: 'Дом-музей Тадеуша Костюшко открыт!'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot031.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot031.jpg'),
            description: 'Открытие музея - первая экскурсия'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot032.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot032.jpg'),
            description: 'Первая экскурсия'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot033.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot033.jpg'),
            description: 'Первые посетители'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot034.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot034.jpg'),
            description: 'Экспонаты музея'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot035.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot035.jpg'),
            description: 'Экспонаты музея'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot036.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot036.jpg'),
            description: 'В музее'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot037.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot037.jpg'),
            description: 'Экспонаты музея'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot038.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot038.jpg'),
            description: 'В музее'
        },
        {
            original: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot039.jpg'),
            thumbnail: require('./../img/virtualtours/KosciuszkoOpeningHouse/ot039.jpg'),
            description: 'Вокруг Дома Костюшко создана зона для отдыха туристов. Здесь, во время праздников, устраиваются театрализованные представления'
        },
    ];

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>23 сентября 2004 года торжественно открыт Мемориальный Дом-музей Тадеуша Костюшко</h2>
                    <div className="onehalf-col-cell">
                        <ImageGallery
                            items={images}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}